/* eslint-disable unicorn/filename-case -- TODO rename later */
import { AuthenticationStore } from "@istari-frontend/auth";
import { IstariV3Client } from "@istari/istari-client";

import { resolveRegistryTarget } from "~/shared/config/registry-target";

const getClientV3SDK = () => {
  const AS = AuthenticationStore();
  const registryAuthToken = AS.getAccessToken() || "";
  const target = resolveRegistryTarget();
  return target.kind === "gateway"
    ? new IstariV3Client({ digitalApiUrl: target.digitalApiUrl, registryAuthToken })
    : new IstariV3Client(target.registryUrl, registryAuthToken);
};

/**
 * TODO: To avoid unnecessary changes the V3 client logic is copied from the V2 client.
 *  Refactor, to avoid new ClientV3SDK creation for each request to the API.
 *  As far as I can see we should be able to listen to the access token changes and update the client.
 *  The additional problem I see is that we don't seem to be handling the refreshing of the token.
 */
const clientV3SDK = new Proxy({} as IstariV3Client, {
  get(target, prop) {
    const client = getClientV3SDK();
    const value = client[prop as keyof IstariV3Client];

    if (typeof value === "function") {
      return value.bind(client);
    }

    return value;
  },
});

export default clientV3SDK;
